import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=fc9a0016"
import script from "./authLayout.vue?vue&type=script&lang=ts"
export * from "./authLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports